import React from "react";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { nzTaxLink } from "@/lib/conversion";

/**
 * Contextual "you might want a real accountant" nudge.
 * Renders only when `show` is true.
 *
 * tone: "warning" (orange/sky) | "info" (gold)
 */
export default function NudgeCard({
  show = true,
  tone = "warning",
  title,
  body,
  cta = "Talk to NZ Taxation Ltd",
  campaign = "calc-nudge",
}) {
  if (!show) return null;
  const isWarning = tone === "warning";
  const ringColor = isWarning ? "var(--secondary)" : "var(--primary)";

  return (
    <div
      className="mt-6 border p-5 flex items-start gap-3"
      style={{
        borderColor: `color-mix(in srgb, ${ringColor} 50%, transparent)`,
        background: `color-mix(in srgb, ${ringColor} 6%, transparent)`,
      }}
      data-testid={`nudge-${campaign}`}
    >
      <AlertTriangle
        size={18}
        className="shrink-0 mt-0.5"
        style={{ color: ringColor }}
      />
      <div className="flex-1 min-w-0">
        <div
          className="font-mono text-xs uppercase tracking-wider"
          style={{ color: ringColor }}
        >
          {title}
        </div>
        <p className="text-sm text-zinc-200 mt-2 leading-relaxed">{body}</p>
        <a
          href={nzTaxLink("/#pricing", campaign)}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 mt-3 font-mono text-xs uppercase tracking-wider"
          style={{ color: ringColor }}
          data-testid={`nudge-cta-${campaign}`}
        >
          {cta} <ArrowRight size={12} />
        </a>
      </div>
    </div>
  );
}
